export type emissionOutputType = "market" | "location";

export enum FeatureFlag {
  ACTIVITY_DATA_VIEW = "ACTIVITY_DATA_VIEW",
  ATLAS_VIEW = "ATLAS_VIEW",
  BESPOKE_DASHBOARDS_VIEW = "BESPOKE_DASHBOARDS_VIEW",
  BESPOKE_EXPLO_DASHBOARDS_VIEW = "BESPOKE_EXPLO_DASHBOARDS_VIEW",
  DATA_COLLECTION_VIEW = "DATA_COLLECTION_VIEW",
  DATA_TRACKER_VIEW = "DATA_TRACKER_VIEW",
  DOCUMENTS_VIEW = "DOCUMENTS_VIEW",
  EMBEDDED_REPORTS = "EMBEDDED_REPORTS",
  EMISSIONS_VIEW = "EMISSIONS_VIEW",
  EXPLO_DASHBOARDS_VIEW = "EXPLO_DASHBOARDS_VIEW", // to be deprecated
  HUB_VIEW = "HUB_VIEW",
  INTEGRATION_HEALTH_VIEW = "INTEGRATION_HEALTH_VIEW",
  LEGACY_SUBMISSIONS_VIEW = "LEGACY_SUBMISSIONS_VIEW",
  METHODOLOGIES_LIST_VIEW = "METHODOLOGIES_LIST_VIEW",
  OUTPUT_API_ACCESS = "OUTPUT_API_ACCESS",
  REQUEST_REPORT_VIEW = "REQUEST_REPORT_VIEW",
  SHOW_HTML_METHODOLOGY_DESCRIPTIONS = "SHOW_HTML_METHODOLOGY_DESCRIPTIONS",
  STANDARD_DASHBOARDS_VIEW = "STANDARD_DASHBOARDS_VIEW",
  STANDARD_EXPLO_DASHBOARDS_VIEW = "STANDARD_EXPLO_DASHBOARDS_VIEW",
  SUBMISSIONS_VIEW = "SUBMISSIONS_VIEW",
  COLLECTION_STATUS_VIEW = "COLLECTION_STATUS_VIEW",
  TRANSACTIONS_VIEW = "TRANSACTIONS_VIEW",
  EMISSIONS_BETA_VIEW = "EMISSIONS_BETA_VIEW",
}

export interface Entity {
  id: string;
  name: string;
  role: string;
  featureFlags: Partial<Record<FeatureFlag, boolean>>;
  defaultEmissionOutputType?: emissionOutputType;
  minimumLogoUrl: string;
  outputApiClientId: string;
  outputApiSecretShown: boolean | null;
  scope3Visible: boolean;
  enableBulkFileUpload?: boolean;
  consolidatedEmissionsLastRefreshed: string | Date | null;
}
